import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class BarLoader extends React.Component {
  render() {
    const { type, size, ...rest } = this.props;
    return (
      <StyledLoader className={`loader ${size} ${type}`} {...rest}><span></span></StyledLoader>
    )
  }
}

BarLoader.defaultProps = {
  type: 'color',
  size: 'large',
  width: 50,
}

BarLoader.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
}

const half = 2;
const smaller = 0.8;
const StyledLoader = styled.div`
&.loader {
  position: absolute;
  top: 50%;
  left: calc(50% - ${props => props.width / half}px);
  transform: translate(-50%, -50%);
  width: ${props => props.width}px;
  height: 10px;
  border-radius: 5px;
  animation: load 2s ease-in-out infinite;
  box-sizing: border-box;
  opacity: 0.4;

  &:before, &:after {
    position: absolute;
    display: block;
    content: "";
    animation: load 2s ease-in-out infinite;
    height: 10px;
    border-radius: 5px;
  }

  &:before {
    top: -20px;
    left: 10px;
    width: ${props => props.width * smaller}px;
    opacity: 0.6;
  }

  &:after {
    bottom: -20px;
    width: ${props => props.width * smaller}px;
    opacity: 0.2;
  }
}

&.light,
&.light::before,
&.light::after {
  background: white;
}

&.dark,
&.dark::before,
&.dark::after {
  background: black;
}

&.color,
&.color::before,
&.color::after {
  background-color: #1A65FF;
}

@keyframes load {
  0% {
    -webkit-transform: translateX(30px);
    transform: translateX(30px);
  }

  50% {
    -webkit-transform: translateX(-20px);
    transform: translateX(-20px);
  }
  100% {
    -webkit-transform: translateX(30px);
    transform: translateX(30px);
  }
}
`

export default BarLoader;



// WEBPACK FOOTER //
// ./src/components/Parts/BarLoader.jsx